/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { LineItem, LineItems } from '@modules/billing-api/customTypes'

export function isActiveItem({ active }: LineItem): boolean {
  return active
}

export function isExpiredItem(lineItem: LineItem): boolean {
  return !lineItem.active && !isFutureItem(lineItem)
}

export function isFutureItem({ start, active }: LineItem): boolean {
  return !active && new Date(start) > new Date()
}

export function getActiveItems(items: LineItem[]): LineItem[] {
  return items.filter((item) => isActiveItem(item))
}

export function getExpiredItems(items: LineItem[]): LineItem[] {
  return items.filter((item) => isExpiredItem(item))
}

export function getFutureItems(items: LineItem[]): LineItem[] {
  return items.filter((item) => isFutureItem(item))
}

type Balance = {
  available: number
  remaining: number
}

export const getActiveBalance = (lineItems: LineItems = []): Balance => {
  let available = 0
  let remaining = 0

  lineItems.forEach(({ active, ecu_quantity, ecu_balance }) => {
    if (active) {
      available += ecu_quantity
      remaining += ecu_balance
    }
  })

  return {
    available,
    remaining,
  }
}
